import React from 'react';
import ImportContainer from '../../common/DataImport/ImportContainer';
import { employeeImportConfig } from '../configs/employeeImportConfig';

const ImportEmployees = () => {
  return (
    <ImportContainer
      config={employeeImportConfig}
      title="Import Individuals"
      backPath="/data-import"
      backLabel="Back to Data Import"
    />
  );
};

export default ImportEmployees;